import DOMPurify from 'isomorphic-dompurify';
import React, { useState, useRef } from 'react';

import { getString } from '../../../../helpers/styles';

export default function CommunityNewTopicEventPopupContent({
  onClose,
  topicXuid,
  addTopicEvent
}) {
  const form = useRef();
  const textInput = useRef();
  const [formIsValid, setFormIsValid] = useState(false);

  return (
    <>
      <div className="communityTopicList-new-topic-event-popup-header">
        <h4 className="communityTopicList-new-topic-event-popup-header-title">
          Jouw reactie
        </h4>

        <button className="popup-close-button" onClick={onClose}>
          &times;
        </button>
      </div>

      <div className="popup-body">
        <form
          ref={form}
          className="communityTopicList-new-topic-event-popup-form"
        >
          <div className="communityTopicList-new-topic-event-text-input-wrap">
            <textarea
              ref={textInput}
              onChange={() => setFormIsValid(form.current.checkValidity())}
              required
              rows="1"
              placeholder="Laat iets van je horen..."
              className="communityTopicList-new-topic-event-text-input"
              maxLength="500"
            />
          </div>
        </form>

        <button
          onClick={() =>
            formIsValid &&
            addTopicEvent({
              variables: {
                topicXuid,
                message: DOMPurify.sanitize(textInput.current.value.trim())
              }
            }).then(() => onClose())
          }
          className={getString([
            {
              value: 'popup-button popup-button-primary',
              condition: true
            },
            {
              value: 'popup-button-disabled',
              condition: !formIsValid
            }
          ])}
        >
          Plaatsen
        </button>
      </div>
    </>
  );
}
